// Quota types taken from Zervant https://github.com/Zervant/zervant-ui/blob/master/src/client/Interfaces/Subscription/SubscriptionInterface.ts
export enum ZervantSubscriptionQuotaType {
  AccountactAccess = 'accounting_access',
  AiExpensesCategorization = 'AI_expenses_categorization',
  AutoBankReconciliation = 'auto_bank_reconciliation',
  Banking = 'banking',
  BankReconciliation = 'bank_reconciliation',
  BookkeepingSupport = 'bookkeeping_support',
  Customers = 'premium_customers',
  CustomInvoiceStyling = 'custom_invoice_styling',
  Downpayment = 'down_payment',
  EInvoice = 'e_invoice',
  EmailAttachment = 'email_attachment',
  Estimates = 'premium_estimate_to_invoice',
  Expenses = 'expenses',
  FreeEmail = 'free_email',
  FreeEstimates = 'free_estimates',
  FreeInvoiceLimit = 'free_invoice_limit',
  FreeInvoicing = 'free_invoice',
  FreeMobile = 'free_mobile',
  FreeProducts = 'free_products',
  FreeReporting = 'free_reports',
  Invoice = 'premium_invoice',
  InvoicesEstimates = 'invoices_estimates',
  LimitedInvoicesEstimates = 'limited_invoices_estimates',
  OnlineBankPayments = 'tpayment_link',
  OnlineCardPayments = 'online_card_payments',
  PaymentSchedule = 'premium_payment_schedule',
  ReceiptScanning = 'receipt_scanning',
  RecurringProfile = 'recurring_profile',
  Reminders = 'premium_reminders',
  Timesheet = 'premium_timesheet',
  Tradenames = 'premium_tradenames',
  VatReturns = 'VAT_returns',
}
